import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { AIPromptUsage, IAIPromptTemplate } from '../../models/AIPromptTemplate';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'template/aiPrompts/library';

/**
 * Levitate's curated prompts for one surface. Its own endpoint rather than template/byType: these belong to no
 * account, and byType filters on the caller's account id, so it can never return them.
 */
export function useAIPromptLibrary({
	enabled = true,
	impersonationContext,
	industry,
	meta = { toastErrorMessage: 'Failed to load the sample prompts' },
	usage,
}: {
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
	industry?: string;
	meta?: LevStandardQueryMeta;
	usage: AIPromptUsage;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<IAIPromptTemplate[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					queryParams: { industry, usage },
					urlPath: 'template/aiPrompts/library',
				}),
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, usage, industry, impersonationContext],
		meta,
	});
}
